import axios from 'axios';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './NavBar.css';

function titlee() {
  return document.getElementById('titlee');
}

let title = titlee();
class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      HomePageUrl: 'https://my-webpage-node.vercel.app/HomePage/',
      loading: false,
      Details: [],
      loginCompleted: null
    }
  }

  async componentDidMount() {
    try {
      let DetailsArr = await axios.get(this.state.HomePageUrl);
      this.setState({
        Details: DetailsArr.data,
        loading: true
      })
    } catch (err) {
      console.log(err)
    }
  }

  render() {
    return (<>
      <div className='LogoDiv'>
        <h2 className={this.props.localStorageData.HomePage.SelectedPage === 0 ? 'Logo-1Sel' : 'Logo-1'} onClick={() => {
          this.props.history.push('/')
          let HomePage = {
            SelectedPage: 0
          }
          this.props.SelectedPage('SelectedPage', HomePage)
          let ZeroValues = {
            Loading: false
          }
          this.props.LoadingPage('ZeroValues', ZeroValues)
          if (this.props.btnPrsd) {
            this.props.clickedBtn(true)
          }
        }}>S</h2>
        <h3 className='Logo-1-Name'>Shanmugavel</h3>
      </div>
      {
        this.state.loading ?
          <div className='DetailsDiv'>
            {this.state.Details ? this.state.Details.map((ite, index) => {
              return (<>
                <h4 className='DetailsHeadingDiv'>{ite?.role}</h4>
              </>)
            }) : ''
            }
          </div>
          : <div className='DetailsDiv'>
            <h4 className='DetailsHeadingDiv'>Loading ...</h4>
          </div>
      }
      <div className='TitleSelDiv'>
        <div className={this.props.localStorageData.HomePage.SelectedPage === 1 ? 'TitleSelDivLink MTAbout TitleCurDivLink' : 'TitleSelDivLink MTAbout'} onClick={() => {
          this.props.history.push('/About')
          let HomePage = {
            SelectedPage: 1
          }
          this.props.SelectedPage('SelectedPage', HomePage)
          let ZeroValues = {
            Loading: false
          }
          this.props.LoadingPage('ZeroValues', ZeroValues)
          if (this.props.btnPrsd) {
            this.props.clickedBtn(true)
          }
        }}>About</div>
        <div className={this.props.localStorageData.HomePage.SelectedPage === 2 ? 'TitleSelDivLink TitleCurDivLink' : 'TitleSelDivLink'} onClick={() => {
          this.props.history.push('/Skills')
          let HomePage = {
            SelectedPage: 2
          }
          this.props.SelectedPage('SelectedPage', HomePage)
          let ZeroValues = {
            Loading: false
          }
          this.props.LoadingPage('ZeroValues', ZeroValues)
          if (this.props.btnPrsd) {
            this.props.clickedBtn(true)
          }
        }}>Skills</div>
        <div className={this.props.localStorageData.HomePage.SelectedPage === 3 ? 'TitleSelDivLink TitleCurDivLink' : 'TitleSelDivLink'} onClick={() => {
          this.props.history.push('/MyWork')
          let HomePage = {
            SelectedPage: 3
          }
          this.props.SelectedPage('SelectedPage', HomePage)
          let ZeroValues = {
            Loading: false
          }
          this.props.LoadingPage('ZeroValues', ZeroValues)
          if (this.props.btnPrsd) {
            this.props.clickedBtn(true)
          }
        }}>My Work</div>
        <div className={this.props.localStorageData.HomePage.SelectedPage === 4 ? 'TitleSelDivLink TitleCurDivLink' : 'TitleSelDivLink'} onClick={() => {
          this.props.history.push('/Contact')
          let HomePage = {
            SelectedPage: 4
          }
          this.props.SelectedPage('SelectedPage', HomePage)
          let ZeroValues = {
            Loading: false
          }
          this.props.LoadingPage('ZeroValues', ZeroValues)
          if (this.props.btnPrsd) {
            this.props.clickedBtn(true)
          }
        }}>Contact</div>
        <div className={this.props.localStorageData.HomePage.SelectedPage === 5 ? 'TitleSelDivLink MBLogin TitleCurDivLink' : 'TitleSelDivLink MBLogin'} onClick={() => {
          if (this.props.localStorageData.NavBarLoginText.Login) {
            this.props.SelectedPage('LoggedInPage', {
              SelectedPage: 0
            })
            title.innerHTML = 'Shan';
            this.props.history.push('/Shan/HomePage')
          } else {
            title.innerHTML = 'Login';
            this.props.history.push('/Login');
          }
          let HomePage = {
            SelectedPage: 5
          }
          this.props.SelectedPage('SelectedPage', HomePage)
          let ZeroValues = {
            Loading: false
          }
          this.props.LoadingPage('ZeroValues', ZeroValues)
          if (this.props.btnPrsd) {
            this.props.clickedBtn(true)
          }
        }}>{this.props.localStorageData?.NavBarLoginText?.NavBarText}</div>
      </div>
      <div className='SocialLink'>
        <a className='SLinkHyper' target="_blank" rel='noreferrer noopener' href='https://www.linkedin.com/in/shanmugaveljagadeesan'>
          <i className="fab fa-linkedin-in LogoSocial"></i>
        </a>
        <a className='SLinkHyper' target="_blank" rel='noreferrer noopener' href='https://github.com/Shanmugavel-J'>
          <i className="fab fa-github LogoSocial LMLeft"></i>
        </a>
        {/* <a className='SLinkHyper' target="_blank" rel='noreferrer noopener' href='https://wa.me/918428037564'>
                    <i className="fab fa-whatsapp LMLeft LogoSocial"></i>
                </a> */}
        <a className='SLinkHyper' target="_blank" rel='noreferrer noopener' href='https://www.instagram.com/_shan_2510/'>
          <i className="fab fa-instagram LMLeft LogoSocial"></i>
        </a>
        <a className='SLinkHyper' target="_blank" rel='noreferrer noopener' href='https://www.facebook.com/shanmugavelj10/'>
          <i className="fab fa-facebook LMLeft LogoSocial"></i>
        </a>
      </div>
      {this.props.localStorageData.NavBarLoginText.Login ? <>
        <div className='LogoutDiv'>
          <div className='LogoutBtn' onClick={(e) => {
            let Data = this.props.localStorageData?.NavBarLoginText;
            Data.Login = false;
            Data.NavBarText = 'Login'
            this.props.LoginText('NavBarLoginText', Data)
          }}>Logout</div>
          <div>Shanmugavel</div>
        </div>
      </> : ''}
    </>);
  }
}

const mapStateToProps = (state) => ({
  localStorageData: state.Reducer
})
const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoadingPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoginText: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBar));